import { Skeleton } from "@/components/ui/skeleton"
import { Separator } from "@/components/ui/separator"

export function BlogSidebarSkeleton() {
    return (
        <aside className="flex flex-col gap-6 w-full sm:max-w-xs bg-card rounded-xl p-6 border shadow-sm">
            {/* Header Section Skeleton */}
            <header className="flex flex-col gap-4">
                <Skeleton className="h-8 w-32" />
                <Skeleton className="h-4 w-48" />
            </header>

            <Separator />

            {/* Search Section Skeleton */}
            <div className="space-y-3">
                <div className="flex items-center gap-2">
                    <Skeleton className="h-4 w-4 rounded" />
                    <Skeleton className="h-4 w-12" />
                </div>
                <Skeleton className="h-11 w-full rounded-md" />
            </div>

            {/* Category Filter Section Skeleton */}
            <div className="space-y-3">
                <div className="flex items-center gap-2">
                    <Skeleton className="h-4 w-4 rounded" />
                    <Skeleton className="h-4 w-16" />
                </div>
                <Skeleton className="h-11 w-full rounded-md" />
            </div>

            {/* Stats Section Skeleton */}
            <div className="pt-2">
                <Skeleton className="h-3 w-24" />
            </div>
        </aside>
    )
}

export function BlogPostsSkeleton() {
    return (
        <div className="bg-card rounded-xl p-6 border shadow-sm">
            <Skeleton className="h-6 w-24 mb-4" />
            <div className="space-y-4">
                <Skeleton className="h-4 w-32 mb-4" />

                {/* Blog Post Skeletons */}
                <div className="grid gap-4">
                    {[1, 2, 3].map((i) => (
                        <div key={i} className="p-4 border rounded-lg bg-muted/20 space-y-2">
                            <Skeleton className="h-5 w-3/4" />
                            <Skeleton className="h-4 w-full" />
                            <Skeleton className="h-4 w-2/3" />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export function BlogPageSkeleton() {
    return (
        <div className="min-h-screen bg-background p-4 sm:p-8">
            <div className="max-w-7xl mx-auto">
                <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
                    {/* Blog Sidebar Skeleton */}
                    <div className="lg:col-span-1">
                        <BlogSidebarSkeleton />
                    </div>

                    {/* Main Content Skeleton */}
                    <div className="lg:col-span-3">
                        <BlogPostsSkeleton />
                    </div>
                </div>
            </div>
        </div>
    )
}
